import { Navigate } from "react-router-dom";
import ForgotPassword from "../../Pages/Login/ForgotPassword";
import Login from "../../Pages/Login/Login";
import RequireAuth from "../RequireAuth";
import { authRoute } from "./authRoute";

export const routesConfig = [
  {
    path: "/",
    element: <Login />
  },
  {
    path: "resetpassword",
    element: <ForgotPassword />
  },
  {
    element: <RequireAuth />,
    children: authRoute
  },
  {
    path: "*",
    element: <Navigate to="/" />
  }
];
